<template>
  <Modal ref="modal">
    <div class="row">{{question}}</div>
    <div>
      <button class="btn btn-danger" v-on:click="$refs.modal.ok()">Tak</button>
      <button class="btn btn-danger" v-on:click="$refs.modal.cancel()">Nie</button>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      question: "",
    };
  },
  methods: {
    ask(question) {
      this.question = question;
      return this.$refs.modal.open();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>